import { generatePath } from "react-router-dom";
import type { AppLocale } from "@akina/infra";
import { AppRoutes } from ".";

export const LOCALE_GET_PARAM = "locale";

//refresh=1 is added to trigger a store refresh in the session page
export const getNextSessionRoute = (treatmentId: string) =>
  `${generatePath(AppRoutes.NextSession, { treatmentId })}?refresh=1`;

export const getUrlWithLocale = (route: AppRoutes, locale: AppLocale) => `${route}?${LOCALE_GET_PARAM}=${locale}`;
